// extracted by css-extract-rspack-plugin
module.exports =  {"quantity":"QuantityCell__quantity___YeRau","quantityPositive":"QuantityCell__quantityPositive___Bapl1","quantityNegative":"QuantityCell__quantityNegative___MC4Mk"};